import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { LANDING } from '@/constants/testIds';

const cells = [
    {
        key: 'escalar',
        title: 'Escalar Mercados',
        desc: 'Adquirir compradores internacionales, abrir canales de distribución y entrar a nuevos mercados B2B.',
        icon: '↗',
        color: 'var(--magenta)',
        testId: LANDING.matrixCardEscalar,
    },
    {
        key: 'innovacion',
        title: 'Innovación & Travel Tech',
        desc: 'Ruta especializada, identificación de proveedores, benchmark internacional y transferencia tecnológica.',
        icon: '◈',
        color: 'var(--teal)',
        testId: LANDING.matrixCardInnovacion,
    },
    {
        key: 'aprender',
        title: 'Aprender de Referentes',
        desc: 'Entender la evolución global del turismo, nuevos modelos de negocio e inspiración curada por país.',
        icon: '☰',
        color: 'var(--amber)',
        testId: LANDING.matrixCardAprender,
    },
    {
        key: 'red',
        title: 'Fortalecer la Red',
        desc: 'Posicionamiento de marca, networking estratégico guiado y construcción de relaciones con aliados potenciales.',
        icon: '⌘',
        color: 'var(--magenta)',
        testId: LANDING.matrixCardRed,
    },
];

const Matrix = () => {
    const [hover, setHover] = useState(null);

    return (
        <section id="matriz" className="relative py-16 md:py-24 border-t border-white/10 bg-diagonal-lines overflow-hidden">
            <div className="mx-auto max-w-[1440px] px-6 md:px-10">
                <div className="grid grid-cols-12 gap-5 md:gap-8 mb-10">
                    <motion.div
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.9 }}
                        className="col-span-12 md:col-span-6"
                    >
                        <div className="overline mb-6">Autodiagnóstico</div>
                        <h2 className="font-display text-3xl sm:text-4xl md:text-5xl lg:text-6xl leading-[0.95] tracking-[-0.02em]">
                            ¿Cuál es tu <span className="italic-accent text-[color:var(--brand)] font-normal">meta</span> internacional?
                        </h2>
                    </motion.div>
                    <motion.div
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.9, delay: 0.15 }}
                        className="col-span-12 md:col-span-5 md:col-start-8"
                    >
                        <p className="text-white/70 text-lg leading-relaxed">
                            Antes de agendar tu sesión, ubícate en la matriz. Cada perfil recibe una estrategia
                            distinta, agenda distinta y compañía de tribu distinta.
                        </p>
                    </motion.div>
                </div>

                <div className="relative grid grid-cols-1 md:grid-cols-2 gap-px bg-white/10 border border-white/10">
                    {cells.map((c, i) => (
                        <motion.div
                            key={c.key}
                            data-testid={c.testId}
                            initial={{ opacity: 0, y: 40 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: '-80px' }}
                            transition={{ duration: 0.8, delay: i * 0.1 }}
                            onMouseEnter={() => setHover(c.key)}
                            onMouseLeave={() => setHover(null)}
                            className="group relative bg-[color:var(--bg)] p-10 md:p-14 min-h-[300px] overflow-hidden cursor-default transition-all duration-500"
                            style={{ backgroundColor: hover === c.key ? 'rgba(255,255,255,0.02)' : undefined }}
                        >
                            {/* Colored corner glow */}
                            <div
                                className="pointer-events-none absolute -top-16 -right-16 h-56 w-56 rounded-full blur-3xl transition-opacity duration-500"
                                style={{ background: c.color, opacity: hover === c.key ? 0.28 : 0.08 }}
                                aria-hidden
                            />
                            <div className="relative flex flex-col h-full">
                                <div className="flex items-start justify-between mb-6">
                                    <div className="overline text-white/50">0{i + 1} / 04</div>
                                    <div
                                        className="font-display text-4xl leading-none"
                                        style={{ color: c.color }}
                                    >
                                        {c.icon}
                                    </div>
                                </div>
                                <h3 className="font-display text-3xl md:text-4xl text-white leading-tight mb-4">
                                    {c.title}
                                </h3>
                                <p className="text-white/65 text-base leading-relaxed max-w-[46ch]">{c.desc}</p>
                                <div className="mt-auto pt-6">
                                    <span
                                        className="text-[11px] uppercase tracking-[0.28em] transition-colors"
                                        style={{ color: hover === c.key ? c.color : 'rgba(255,255,255,0.4)' }}
                                    >
                                        Ruta {c.key} —→
                                    </span>
                                </div>
                            </div>
                        </motion.div>
                    ))}

                    {/* Center overlay label */}
                    <div className="hidden md:flex absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 h-16 w-16 items-center justify-center rounded-full border border-white/20 bg-black text-[10px] uppercase tracking-[0.22em] text-white/70 backdrop-blur">
                        Tribu
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Matrix;
